import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/filter.svg';

const FilterIcon = ({ fill, ...props }) => (
   <Icon {...props} fill={(fill ? fill : '#ffffff')} />
);

export default FilterIcon;
